// Short one-shot sound effects, played across quizzes, daily tests, and
// badge unlocks to reinforce feedback. Mirrors the mobile app's
// SoundEffectService (same three sounds, same volume).
import { assetUrl } from '../config/constants';

const VOLUME = 0.2;

const SOUNDS = {
  correct: assetUrl('sounds/ok.mp3'),
  wrong: assetUrl('sounds/wrong.mp3'),
  celebration: assetUrl('sounds/celebration-wow.mp3'),
};

function play(src) {
  try {
    const audio = new Audio(src);
    audio.volume = VOLUME;
    audio.play().catch(() => {});
  } catch {
    // ignore — sound is a nice-to-have, never block on it
  }
}

export const SoundEffectService = {
  playCorrect: () => play(SOUNDS.correct),
  playWrong: () => play(SOUNDS.wrong),
  playCelebration: () => play(SOUNDS.celebration),
};
